module.exports = __webpack_public_path__ + "img/icon-profile.b1ecf5ff.svg";